import React from 'react'
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Stack,
  Typography,
  SxProps,
  Theme,
} from '@mui/material'
import {NEUTRAL_SCALE} from 'src/theme-new/tokens'

interface Option {
  value: string
  label: string
}

interface CheckboxGroupNewProps {
  value: string[]
  onChange: (value: string[]) => void
  options: Option[]
  label?: string
  disabled?: boolean
  error?: boolean
  helperText?: string
  row?: boolean
  sx?: SxProps<Theme>
  // When set, once `value` reaches this length, remaining unchecked options are disabled
  // so the user can't select more than this many.
  maxSelected?: number
}

export default function CheckboxGroupNew({
  value,
  onChange,
  options,
  label,
  disabled,
  error,
  helperText,
  row = true,
  sx,
  maxSelected,
}: CheckboxGroupNewProps): JSX.Element {
  const handleChange = (optValue: string, checked: boolean) => {
    if (checked) {
      if (maxSelected !== undefined && value.length >= maxSelected) return
      onChange([...value, optValue])
    } else {
      onChange(value.filter(v => v !== optValue))
    }
  }

  return (
    <Stack spacing={0.5} sx={sx}>
      {label && (
        <Typography variant="caption" sx={{fontWeight: 600, color: NEUTRAL_SCALE[700], textTransform: 'uppercase', letterSpacing: '0.05em'}}>
          {label}
        </Typography>
      )}
      <FormGroup row={row}>
        {options.map(opt => {
          const checked = value.includes(opt.value)
          const optionDisabled = disabled || (!checked && maxSelected !== undefined && value.length >= maxSelected)
          return (
            <FormControlLabel
              key={opt.value}
              disabled={optionDisabled}
              control={
                <Checkbox
                  size="small"
                  color="primary"
                  checked={checked}
                  onChange={(e) => handleChange(opt.value, e.target.checked)}
                />
              }
              label={<Typography variant="body2">{opt.label}</Typography>}
            />
          )
        })}
      </FormGroup>
      {helperText && (
        <Typography variant="caption" sx={{color: error ? 'error.main' : NEUTRAL_SCALE[500]}}>
          {helperText}
        </Typography>
      )}
    </Stack>
  )
}
